import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Table = styled.table`
  box-shadow: rgb(206, 212, 222) 0px 0px 0px 1px;
  background-color: transparent;
  border-collapse: collapse;
  color: rgb(19, 22, 31);
  overflow-y: hidden;
  overflow-x: initial;
  width: 100%;
  font-family: Courier new;
  font-size: 14px;
  padding: 0;
  border-spacing: 0;
  border-style: hidden;
  border-radius: 2px;
  table-layout: auto;
`;

const Thead = styled.thead`
  color: rgb(125, 137, 156);
  background: rgb(238, 241, 245);
  text-align: left;
`;

const Th = styled.th`
  font-weight: 400;
  padding: 20px;
`;

const Tbody = styled.tbody`
  > tr {
    border-top: 1px solid rgb(206, 212, 222);
  }
`;

const Td = styled.td`
  line-height: 2;
  font-weight: 200;
  padding: 12px 20px;
`;

type Child = {
  name: string;
  description: string;
  type: string;
  defaultValue: string;
  responsive: string;
};

type Props = {
  children: Child[];
};

function PropsTable({ children }: Props): JSX.Element {
  return (
    <Table>
      <Thead>
        <tr>
          <Th>Name</Th>
          <Th>Description</Th>
          <Th>Type</Th>
          <Th>Default value</Th>
          <Th>Responsive</Th>
        </tr>
      </Thead>
      <Tbody>
        {children.map((prop) => (
          <tr key={prop.name}>
            <Td>{prop.name}</Td>
            <Td>{prop.description}</Td>
            <Td>{prop.type}</Td>
            <Td>{prop.defaultValue}</Td>
            <Td>{prop.responsive}</Td>
          </tr>
        ))}
      </Tbody>
    </Table>
  );
}

PropsTable.propTypes = {
  children: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};

// eslint-disable-next-line import/no-default-export
export default PropsTable;
